import { AccountCustomServiceFee, ApiAccountCustomServiceFee } from '@types'

interface LoadCustomServiceFeeTemplateCoordinator {
  RestService: {
    get: (
      url: string,
      params: { template: string },
    ) => Promise<ApiAccountCustomServiceFee>
  }
  HandleError: any
  pResponseCustomServiceFee: (
    data: ApiAccountCustomServiceFee,
  ) => AccountCustomServiceFee
}

export const LoadCustomServiceFeeTemplate =
  ({
    RestService,
    HandleError,
    pResponseCustomServiceFee,
  }: LoadCustomServiceFeeTemplateCoordinator) =>
  async (template: string) => {
    try {
      const response = await RestService.get(
        '/api/admin/accounts/service_fee_template',
        { template },
      )

      return pResponseCustomServiceFee(response)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
